/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { borderRadius, gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { media } from '@atlassian/bitkit-responsive';

import { TableHeader } from 'src/components/pageable-table';
import RelativeLink from 'src/components/relative-link';
import { link, overflowEllipsis } from 'src/styles/mixins';

export const RepositoryContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const RepositoryRow = styled.tr({
  height: `${gridSize() * 8}px`,
  '&:hover, &:focus': {
    backgroundColor: token('elevation.surface.raised.hovered'),
    boxShadow: token('elevation.shadow.raised'),
    borderRadius: `${borderRadius()}px`,
  },
});

export const RepositoryInfo = styled.div({
  padding: `${gridSize() / 2}px ${gridSize()}px`,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const RepositoryLink = styled(RelativeLink)(link);

export const CenteredColumn = styled.td({
  textAlign: 'center',
  padding: `${gridSize() * 3}px`,
});

export const TableHeaderPrivateColumn = styled.th({
  width: '34px',
});

export const PaginationContainer = styled.div({
  padding: `${gridSize()}px 0`,
  marginBottom: `${gridSize() * 4}px`,
});

export const DateWrapper = styled.small(
  {
    display: 'none',
    margin: 0,
  },
  media.upToSmall(`
    display: block;
    ${overflowEllipsis('140px')};
  `)
);

export const ProjectNameUpdatedContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  '& a, & a:hover, & a:focus': {
    color: token('color.text.subtlest'),
  },
});

export const Info = styled.small(
  {
    margin: `${gridSize() * 0.25}px ${gridSize() * 0.25}px 0 0`,
    display: 'block',
  },
  overflowEllipsis()
);

export const DescriptionWrapper = styled.div({
  color: token('color.text.subtlest'),
});

export const RepositoryInfoTableHeader = styled(TableHeader)(
  media.upToSmall(`
    width: 70%;
  `)
);

export const BuildStatusTableHeader = styled(TableHeader)({
  overflow: 'visible',
});
